import { Controller } from '@hotwired/stimulus';

// Bootstrap 3 の CSS のまま、jQuery の Bootstrap プラグインと同じクラスを付け外しして切り替える
export default class extends Controller {
  // action="tabs#show"
  show(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const item = link.closest('li');
    if (item.classList.contains('active')) return;

    for (const active of this.element.querySelectorAll(':scope > li.active')) {
      active.classList.remove('active');
      active.querySelector('a')?.setAttribute('aria-expanded', 'false');
    }
    item.classList.add('active');
    link.setAttribute('aria-expanded', 'true');

    const pane = document.querySelector(link.getAttribute('href'));
    for (const active of pane.parentElement.querySelectorAll(
      ':scope > .active',
    )) {
      active.classList.remove('active', 'in');
    }
    pane.classList.add('active');
    if (pane.classList.contains('fade')) {
      // 表示した直後に in を付けるとトランジションが起きないので、レイアウトを確定させてから付ける
      pane.offsetWidth;
      pane.classList.add('in');
    }
  }
}
